import { render, staticRenderFns } from "./InvoiceOtherDetails.vue?vue&type=template&id=057698f2&"
import script from "./InvoiceOtherDetails.vue?vue&type=script&lang=js&"
export * from "./InvoiceOtherDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports